export const MODAL_NAMES = {
  BLACK_FRIDAY_SPECIAL_JP: 'BLACK_FRIDAY_SPECIAL_JP',
  ABOUT_BATTERY: 'about_battery',
  ABOUT_BATTERY_UPDATED: 'about_battery_updated',
  PAYPAY: 'paypay',
  VERIFIED_REFURBISHED_JPP: 'VERIFIED_REFURBISHED_JPP',
  SELLER_INFO: 'SELLER_INFO',
  SIM_UNLOCKED: 'SIM_UNLOCKED',
  BACK_UP: 'BACK_UP',
  CONDITION: 'CONDITION',
  ADD_TO_CART: 'ADD_TO_CART',
}

export const BATTERY_OFFER_TYPE = {
  STANDARD: 0,
  NEW: 7,
  NINETY_NINE: 9,
} as const
